<template>
  <div :class="{ isHideNavigation: hideNavigation }">
    <p-vue-table responsiveLayout="scroll" :value="readings" dataKey="ID">
      <p-vue-column field="ReadDate" :header="__('on the date')">
        <template #body="{ data }">
          {{
            isFirstReading(data.ID) ? __("Initial reading") : dateFormat(new Date(data.ReadDate))
          }}
        </template>
      </p-vue-column>
      <p-vue-column field="ReadCount" :header="__('Meter reading')">
      </p-vue-column>
      <p-vue-column field="ReadDate" :header="__('Total consumption')">
        <template #body="{ data }">
          {{
            isFirstReading(data.ID)
              ? ""
              : __u_value__({
                  value: getTotalConsumption(data),
                  unit: "number-f",
                })
          }}
        </template>
      </p-vue-column>
      <p-vue-column field="ReadDate">
        <template #body="{ data }">
          <a
            v-if="data.PathImg"
            href="#"
            @click.prevent="showBigImg(data.PathImg)"
            ><i class="pi pi-eye "></i>
          </a>
        </template>
      </p-vue-column>
    </p-vue-table>
  </div>
  <div v-if="hideNavigation" class="p-d-flex p-jc-end">
    <p-vue-button
      :label="__('Return')"
      class="p-button-rounded p-button-success p-ml-3 p-mt-2"
      @click="back()"
    />
  </div>

  <p-img
    v-if="showImg"
    :imgPath="showImg"
    :openModal="true"
    @return="showImg = null"
    :allImages="allImages"
  />
  <i-plus-button
    @click="
      $router.push({
        name: 'ConsumptionReport',
        params: {
          meterid: meterID,
          bid: BID,
        },
      })
    "
    :text="__('Enter meter reading')"
  />
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { errorReceived, dateFormat } from "@/services/apointUtil";
import PImg from "@/components/partials/p-img";
import { mapState } from "vuex";
// import { __ } from "@/plugins/i18n/";

export default {
  components: {
    PImg,
  },
  data() {
    return {
      meterID: this.$route.params.meterid,
      BID: this.$route.params.bid,
      readings: [],
      dateFormat,
      showImg: null,
      allImages: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("MeterID", this.meterID, apiPType.Int)];
      callProc("App_GetReadingsToMeter", procParams)
        .then((result) => {
          this.$store.dispatch("doLoading", false);
          result = JSON.parse(result);
          this.readings = result.Table;
          // console.log(this.readings);
        })
        .catch(() => {
          errorReceived("App_GetReadingsToMeter");
        });
    },
    showBigImg(imgPath) {
      this.showImg = imgPath;
      this.allImages = [];
      this.allImages.push({ imgPath: imgPath, imgSubject: "" });
    },
    back() {
      this.$router.go(-1);
    },
    getTotalConsumption(currentRow) {
      const currentReadCount = currentRow.ReadCount;
      const closestPreviousObj = this.readings.find(
        (obj) => new Date(obj.ReadDate) < new Date(currentRow.ReadDate)
      );

      if (closestPreviousObj) {
        const previousReadCount = closestPreviousObj.ReadCount;
        return currentReadCount - previousReadCount;
      } else {
        return currentReadCount;
      }
    },
    isFirstReading(id) {
      let index = this.readings.findIndex((f) => f.ID == id);
      return index == this.readings.length - 1;
    },
  },
  computed: {
    ...mapState({
      hideNavigation: (state) => state.api.hideNavigation,
    }),
  },
};
</script>

<style scoped>
.isHideNavigation {
  height: 83vh;
}
</style>
